import { State } from '@rtls/core/models/thing/state.model';
import { nullable, randomName, randomSentence } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const stateFactory = Factory.makeFactory<State>({
	id: Factory.each((i) => nullable(i)),
	key: Factory.each(() => randomName()),
	keyTranslation: Factory.each(() => nullable(randomSentence())),
	translation: Factory.each(() => nullable(randomSentence())),
});
